/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_RejectedInputs */



/**
* | output |
* | --- |
* | "A change to this document was rejected" |
*
* @param {Artifact_Edit_RejectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_rejected = /** @type {((inputs?: Artifact_Edit_RejectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_RejectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Änderung an diesem Dokument wurde abgelehnt")
	return /** @type {LocalizedString} */ ("A change to this document was rejected")
});